import { useState } from "react";
import {
  updateUserSchema,
  UpdateUserSchema,
  useUpdateUser as useUpdateUserMutation,
} from "@/lib/api/user.ts";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

export function useUpdateUser(
  defaultValues: { userId: string } & Partial<UpdateUserSchema>,
) {
  const { mutateAsync: updateUser } = useUpdateUserMutation();

  const [fieldState, setFieldState] = useState<
    Partial<Record<keyof UpdateUserSchema, boolean>>
  >({});

  const form = useForm<UpdateUserSchema>({
    resolver: zodResolver(updateUserSchema),
    defaultValues,
  });

  const handleUpdate = async (
    field: keyof UpdateUserSchema,
    value: UpdateUserSchema[keyof UpdateUserSchema],
  ) => {
    if (fieldState[field]) return;

    setFieldState((prev) => ({
      ...prev,
      [field]: true,
    }));

    try {
      await updateUser({
        userId: defaultValues.userId,
        params: {
          [field]: value,
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setFieldState((prev) => ({
        ...prev,
        [field]: false,
      }));
    }
  };

  return {
    form,
    fieldState,
    handleUpdate,
  };
}
